import * as React from 'react';
import {IYearCatalogs} from "../interfaces";

export const YearCatalogsContext: React.Context<IYearCatalogs> = React.createContext(undefined);

export const YearCatalogsProvider = YearCatalogsContext.Provider;
export const YearCatalogsConsumer = YearCatalogsContext.Consumer;
